import type {
    NCoreUIKitIcon
} from "../../types";
import {
    MoreHorizontalIcon,
    ChevronRightIcon,
    ChevronLeftIcon
} from "lucide-react-native";
import AnimatedIcon from "../animatedIcon";

export const PaginationPreviousIcon: NCoreUIKitIcon = ({
    customColor,
    color,
    size
}) => <AnimatedIcon
    customColor={customColor}
    animationTrigger="hover"
    icon={ChevronLeftIcon}
    animation="signature"
    color={color}
    size={size}
/>;

export const PaginationNextIcon: NCoreUIKitIcon = ({
    customColor,
    color,
    size
}) => <AnimatedIcon
    customColor={customColor}
    animationTrigger="hover"
    icon={ChevronRightIcon}
    animation="signature"
    color={color}
    size={size}
/>;

export const PaginationEllipsisIcon: NCoreUIKitIcon = ({
    customColor,
    size
}) => <MoreHorizontalIcon
    color={customColor}
    size={size}
/>;
